import * as PIXI        from "pixi.js";
// import { CanvasExtract } from '@pixi/canvas-extract';
// import { extensions } from '@pixi/core';
//import { CanvasRenderer } from '@pixi/canvas-renderer';


import '@interactjs/auto-start'
import interact         from "interactjs";
import Asset            from "./Asset";
import TextAsset        from "./TextAsset";
import "pixi-tps-loader";
import AudioManager     from "./AudioManager";
import { triggerEvent } from "../_utils";

export default class Collage
{
	constructor ( canvas )
	{

		// extensions.add(CanvasExtract);


		this.canvas          = canvas;
		this.backgroundAlpha = 0;
		this.backgroundColor = 0x014B83;
		this.resolution      = window.devicePixelRatio;
		this.antialias       = true;

		this.arrAssets              = [];
		this.wasCancel              = false;
		this.wasOpenBeforePlayScene = true;

		this.audioManager = new AudioManager();
		this.buildCanvas();
		this.bindEvents();

		triggerEvent( window, 'show-thematique-intro-modal' );
	}

	get canvasWidth ()
	{
		return this.canvas.offsetWidth
	}

	get canvasHeight ()
	{
		return this.canvas.offsetHeight;
	}

	prepareDraggable ()
	{


		//define draggable
		interact( ".draggable" )
			.draggable(
				{
					inertia     : true,
					autoScroll  : true,
					manualStart : true,
					listeners   :
						{
							//start: this.cloneDraggable.bind(this),
							move : this.moveDraggable.bind( this ),
							end  : this.endDrag.bind( this ),
						},
				} )
			.on( "down", this.cloneDraggable.bind( this ) )
			.on( "hold", this.onHold.bind( this ) )
			.on( "cancel", this.onCancel.bind( this ) )


		//define droppable
		interact( "canvas" )
			.dropzone(
				{
					ondrop : this.onItemDrop.bind( this ),


				},
			)

	}

	prepareClickable ()
	{
		let nodelistBtnMusic = document.querySelectorAll( "[data-music]" );

		let arrBtns = Array.from( nodelistBtnMusic );

		arrBtns.forEach( btn =>
		{
			btn.addEventListener( "click", event => this.switchMusic( btn ) );
		} )
	}

	switchMusic ( btn )
	{
		let strURL = btn.getAttribute( "data-music" );

		let audio = document.querySelector( "#background-music" );
		let src   = document.querySelector( "#audio-mp3" );

		src.setAttribute( "src", strURL );
		audio.load();

		const playBtn = document.querySelector( '#play-scene' );
		playBtn.click();
		console.log( strURL );
	}

	onHold ( event )
	{
		console.log( "onHold" );
	}

	onCancel ( event )
	{
		console.log( "onCancel" );

	}

	endDrag ( event )
	{
		console.log( "endDrag", this.wasCancel );

		let interaction = event.interaction;

		var canGesture = interaction.target && interaction.target.options.gesture.enabled;
		let target     = event.target;
		console.log( "endDrag", event, interaction )
		target.remove();

		let arrBottomPanel = Array.from( document.querySelectorAll( ".bottom-panel" ) );
		arrBottomPanel.forEach( panel => this.removeClass( panel, "low-opacity" ) )


		this.enableScroll();

	}

	onItemDrop ( event )
	{
		console.log( "onItemDrop", this.wasCancel );
		let target = event.relatedTarget;
		let img    = target.querySelector( "img" );
		this.addAsset( img, target )

		this.enableScroll();


	}

	moveDraggable ( event )
	{
		let target = event.target;


		let left = event.page.x + this.currentOffset.x;
		let top  = event.page.y + this.currentOffset.y;

		target.style.left = `${left}px`;
		target.style.top  = `${top}px`;

		if ( event.client.y < 50 )
		{
			window.scrollBy( { top : -15, left : 0, behavior : "instant" } )

			//top -= 25;
			target.style.top = `${top}px`;
		} else if ( event.client.y + 100 >= this.canvasHeight )
		{
			window.scrollBy( { top : 15, left : 0, behavior : "instant" } )

			//top += 25;
			target.style.top = `${top}px`;
		}

	}

	cloneDraggable ( event )
	{


		const interaction = event.interaction;

		if ( interaction.pointerIsDown && !interaction.interacting() )
		{

			this.disableScroll();

			let oe     = event.originalEvent;
			let target = oe.srcElement;
			let ratio  = { x : oe.offsetX / target.width, y : oe.offsetY / target.height };
			ratio      = { x : 0.5, y : 0.5 };

			let arrBottomPanel = Array.from( document.querySelectorAll( ".bottom-panel" ) );
			arrBottomPanel.forEach( panel => this.addClass( panel, "low-opacity" ) )

			const clone = this.cloneAsset( event.currentTarget, event.originalEvent, ratio )
			interaction.start( { name : "drag" }, event.interactable, clone );

			console.log( 'clone', clone )

			//this.offset = {x: event.originalEvent.offsetX, y: event.originalEvent.offsetY };

		}


	}

	addClass ( el, cssClass )
	{
		el.classList.add( cssClass );
	}

	removeClass ( el, cssClass )
	{
		el.classList.remove( cssClass );
	}

	disableScroll ()
	{
		this.currentPanel.classList.add( "block-touch-actions" );
		this.containerCanvas.classList.add( "block-touch-actions" )
		//this.siteWrapper.classList.add("block-touch-actions")

	}

	enableScroll ()
	{
		this.currentTargetSource.style.display = "block";
		this.currentPanel.classList.remove( "block-touch-actions" )
		this.containerCanvas.classList.remove( "block-touch-actions" )
		//this.siteWrapper.classList.remove("block-touch-actions")
	}

	buildCanvas ()
	{
		this.app = new PIXI.Application
		(
			{
				view            : this.canvas,
				resolution      : this.resolution,
				backgroundAlpha : this.backgroundAlpha,
				backgroundColor : this.backgroundColor,

				width     : this.canvasWidth,
				height    : this.canvasHeight,
				antialias : this.antialias,

			},
		);

        let bgImg = document.querySelector("#bg-img");

        if (bgImg)
        {
            bgImg.style.height = this.canvasHeight + "px";
        }

		this.container = new PIXI.Container();
		this.app.stage.addChild( this.container );


		this.containerMask = new PIXI.Container();
		this.app.stage.addChild( this.containerMask );

		this.gfxMask = new PIXI.Graphics();
		this.gfxMask.beginFill( 0x990000, 0.5 );
		this.gfxMask.drawRect( 0, 0, this.canvasWidth, this.canvasHeight );
		this.gfxMask.endFill();

		window.pixi            = this;
		window.pixiAppInstance = this.app;
		window.pixiStage       = this.app.stage;

		this.loadBackground();
		this.buildTracker();
	}


	bindEvents ()
	{

		this.panelObjet      = document.querySelector( "#asset-type-objet" );
		this.panelVegetaux   = document.querySelector( "#asset-type-nature" );
		this.panelAnimaux    = document.querySelector( "#asset-type-animal" );
		this.panelPersonnage = document.querySelector( "#asset-type-personnage" );
		this.panelMusique    = document.querySelector( "#asset-type-musique" );

		this.btnObjet       = document.querySelector( "#btn-objets" );
		this.btnVegetaux    = document.querySelector( "#btn-vegetaux" );
		this.btnAnimaux     = document.querySelector( "#btn-animaux" );
		this.btnPersonnages = document.querySelector( "#btn-personnages" );
		this.btnMusiques    = document.querySelector( "#btn-musiques" );


		this.tabObjet      = document.querySelector( "#tab-objet" );
		this.tabVegetaux   = document.querySelector( "#tab-nature" );
		this.tabAnimaux    = document.querySelector( "#tab-animal" );
		this.tabPersonnage = document.querySelector( "#tab-personnage" );
		this.tabMusique    = document.querySelector( "#tab-musique" );


		this.siteWrapper     = document.querySelector( ".site-wrapper" );
		this.containerCanvas = document.querySelector( "canvas" );


		this.btnObjet.addEventListener( "click", event => this.switchPanel( this.panelObjet, this.btnObjet ) );
		this.btnVegetaux.addEventListener( "click", event => this.switchPanel( this.panelVegetaux, this.btnVegetaux ) );
		this.btnAnimaux.addEventListener( "click", event => this.switchPanel( this.panelAnimaux, this.btnAnimaux ) );
		this.btnPersonnages.addEventListener( "click", event => this.switchPanel( this.panelPersonnage, this.btnPersonnages ) );
		this.btnMusiques.addEventListener( "click", event => this.switchPanel( this.panelMusique, this.btnMusiques ) );

		this.tabObjet.addEventListener( "click", event => this.toggleTab( this.panelObjet ) );
		this.tabVegetaux.addEventListener( "click", event => this.toggleTab( this.panelVegetaux ) );
		this.tabAnimaux.addEventListener( "click", event => this.toggleTab( this.panelAnimaux ) );
		this.tabPersonnage.addEventListener( "click", event => this.toggleTab( this.panelPersonnage ) );
		this.tabMusique.addEventListener( "click", event => this.toggleTab( this.panelMusique ) );

		this.switchPanel( this.panelVegetaux, this.btnVegetaux );


		this.inputText = document.querySelector( "#input-text" );


		//TRANSFORM
		this.panelTransform = document.querySelector( "#panel-transform" );

		this.btnScale     = document.querySelector( "#btn-scale" );
		this.btnRotate    = document.querySelector( "#btn-rotate" );
		this.btnFlip      = document.querySelector( "#btn-flip" );
		this.btnDuplicate = document.querySelector( "#btn-duplicate" );
		this.btnValid     = document.querySelector( "#btn-valid" );
		this.btnDelete    = document.querySelector( "#btn-delete" );

		this.btnTransformActive = this.btnScale;

		this.btnFlip.addEventListener( "click", event => this.flip() );
		this.btnDuplicate.addEventListener( "click", event => this.duplicate() );
		this.btnValid.addEventListener( "click", event => this.onChangeActive() );
		this.btnScale.addEventListener( "click", event => this.changeTransform( "scale" ) );
		this.btnRotate.addEventListener( "click", event => this.changeTransform( "rotate" ) );
		this.btnDelete.addEventListener( "click", event => this.deleteCurrent( "rotate" ) );


		//other
		this.btnDownload = document.querySelector( "#btn-download" );
		this.btnDownload.addEventListener( "click", event => this.save() );

	}

	closeCurrentTab ()
	{
		return this.toggleTab( this.currentPanel, true );
	}

	toggleTab ( panel, onlyClose = false, onlyOpen = false )
	{
		let style     = window.getComputedStyle( panel );
		let bottom    = style.getPropertyValue( "bottom" );
		let bottomPos = parseInt( bottom ?? 0 );
		let isOpen    = bottomPos === 0 || Number.isNaN( bottomPos );

		if ( !isOpen && onlyClose )
			return false;

		if ( isOpen && onlyOpen )
			return true;

		let height         = style.getPropertyValue( "height" );
		panel.style.bottom = isOpen ? `-${height}` : "0px";

		return isOpen;
	}

	trackHandle ( event )
	{
		console.log( "trackHandle", event );
		// this.contHandleTracker.visible = true;
		// this.contHandleTracker.interactive = true;
		// this.currentHandle = handle;
		//
		// this.container.addChild(this.contHandleTracker);

		//window.addEventListener("pointermove", )

	}


	async loadBackground (cacheBuster = "")
	{
		let canvas = document.querySelector( "#canvas" );
		let url    = canvas.getAttribute( "data-bg-url" ) + cacheBuster;


		//url = url.replace("https://savoirs-legendaires.s3.amazonaws.com/", "/s3/")
		//url += "?r=" + Math.random() + "_" + Math.random()

		//const texture = PIXI.Texture.from( url, { resourceOptions : { autoLoad : false } } );
        const options = {
            crossOrigin: 'anonymous',
            scaleMode: PIXI.SCALE_MODES.LINEAR,
            resourceOptions: {
                autoLoad: true,
            }
        };

        let texture;
        try
        {
            console.log("Loading texture", url);
            texture = await PIXI.Texture.fromURL(url , options);
        }

        catch (e)
        {
            console.log("Error loading texture", e);
            let uuid = parseInt(Math.random() * 1000000, 32).toString();
            setTimeout(() => this.loadBackground("?rand" + uuid), 200);
            return;
        }

		//await texture.baseTexture.resource.load();

		const textureRatio  = texture.width / texture.height;
		const textureCanvas = this.canvasWidth / this.canvasHeight;

		const sprite = new PIXI.Sprite( texture );

		let pixels       = this.app.renderer.plugins.extract.pixels( sprite );
		let spriteWidth  = sprite.width >> 0;
		let spriteHeight = sprite.height >> 0;
		let halfWidth    = ((spriteWidth / 2) >> 0);
		let halfHeight   = ((spriteHeight / 2) >> 0);


		let leftPixelsIndex   = halfHeight * spriteWidth;
		let rightPixelsIndex  = halfHeight * spriteWidth + (spriteWidth - 1);
		let topPixelsIndex    = halfWidth;
		let bottomPixelsIndex = (spriteHeight - 1) * spriteWidth + halfWidth;

		let leftPixel   = this.getRGB( pixels, leftPixelsIndex );
		let rightPixel  = this.getRGB( pixels, rightPixelsIndex );
		let topPixel    = this.getRGB( pixels, topPixelsIndex );
		let bottomPixel = this.getRGB( pixels, bottomPixelsIndex );

		let arrColor = [ leftPixel, rightPixel, topPixel, bottomPixel ];
		let bgColor  = arrColor[ (Math.random() * arrColor.length - 0.0001) >> 0 ];

		let containerCanvas                   = document.querySelector( "#container-canvas" );
		containerCanvas.style.backgroundColor = "#" + bgColor.toString( 16 );




		if ( textureRatio < textureCanvas )
		{
			sprite.height  = this.canvasHeight;
			sprite.scale.x = sprite.scale.y;

			sprite.x = (this.canvasWidth - sprite.width) / 2;


			this.bgLeftBorder = new PIXI.Graphics();
			this.bgLeftBorder.beginFill( leftPixel, 1 );
			this.bgLeftBorder.drawRect( 0, 0, sprite.x, this.canvasHeight );
			this.bgLeftBorder.endFill();

			this.container.addChild( this.bgLeftBorder );


			this.bgRightBorder = new PIXI.Graphics();
			this.bgRightBorder.beginFill( rightPixel, 1 );
			this.bgRightBorder.drawRect( 0, 0, sprite.x, this.canvasHeight );
			this.bgRightBorder.endFill();

			this.bgRightBorder.x = this.canvasWidth - sprite.x;

			this.container.addChild( this.bgRightBorder );


		} else
		{
			sprite.width   = this.canvasWidth;
			sprite.scale.y = sprite.scale.x;

			sprite.y = (this.canvasHeight - sprite.height) / 2;


			this.bgTopBorder = new PIXI.Graphics();
			this.bgTopBorder.beginFill( topPixel, 1 );
			this.bgTopBorder.drawRect( 0, 0, sprite.width, sprite.y );
			this.bgTopBorder.endFill();

			this.container.addChild( this.bgTopBorder );


			this.bgBottomBorder = new PIXI.Graphics();
			this.bgBottomBorder.beginFill( bottomPixel, 1 );
			this.bgBottomBorder.drawRect( 0, 0, sprite.width, sprite.y );
			this.bgBottomBorder.endFill();

			this.bgBottomBorder.y = this.canvasHeight - sprite.y;

			this.container.addChild( this.bgBottomBorder );
		}


        this.app.stage.addChild( this.container );
        this.app.stage.addChild( this.containerMask );
		this.container.addChild( sprite );

		console.log( url );




	}


	playScene ()
	{
		this.onChangeActive( null );
		this.arrAssets.forEach( a => a.play() )
		this.wasOpenBeforePlayScene = this.closeCurrentTab();
	}

	pauseScene ()
	{
		this.arrAssets.forEach( a => a.pause() )

		this.audioManager.reset();

		if ( this.wasOpenBeforePlayScene )
			this.toggleTab( this.currentPanel, false, true );
	}

	getRGB ( pixels, startIndex )
	{
		startIndex *= 4;
		let r = pixels[ startIndex + 0 ];
		let g = pixels[ startIndex + 1 ];
		let b = pixels[ startIndex + 2 ];

		let rgb = (r << 16) + (g << 8) + b;

		return rgb;
	}

	buildTracker ()
	{
		this.contHandleTracker = new PIXI.Graphics();
		this.contHandleTracker.beginFill( 0xFFFFFF, 0.0001 );
		this.contHandleTracker.drawRect( 0, 0, this.canvasWidth, this.canvasHeight )
		this.contHandleTracker.endFill();

		this.container.addChild( this.contHandleTracker );

		this.contHandleTracker.visible = false;

		this.fctDragHandle    = this.dragHandle.bind( this );
		this.fctDragHandleEnd = this.dragHandleEnd.bind( this );

		this.contHandleTracker.on( "pointermove", this.fctDragHandle );
		this.contHandleTracker.on( "pointerup", this.fctDragHandleEnd );
		this.contHandleTracker.on( "pointerupoutside", this.fctDragHandleEnd );
	}

	dragHandle ( event )
	{

		if ( this.currentHandle )
		{
			this.currentHandle.onDrag( event );
		}

	}

	dragHandleEnd ( event )
	{

		if ( this.currentHandle )
		{
			this.currentHandle.onDragEnd( event );
			this.currentHandle = null;
		}

		this.contHandleTracker.visible = false;
	}


	switchPanel ( displayPanel, clickBtn )
	{
		if ( displayPanel === this.currentPanel )
		{
			//since we are clicking on the current panel, we want to show/hide it
			this.toggleTab( displayPanel );
			return;
		}


		if ( this.currentPanel )
		{
			this.currentPanel.classList.add( "panel-hidden" );
		}

		if ( this.currentBtn )
		{
			this.currentBtn.classList.remove( "selected" );
		}

		this.currentPanel = displayPanel;
		this.currentBtn   = clickBtn;

		this.currentPanel.classList.remove( "panel-hidden" );
		this.currentBtn.classList.add( "selected" );
	}


	cloneAsset ( target, event, ratio )
	{
		this.currentTargetSource = target;
		let duplicate            = this.currentItemDrag = target.cloneNode( true );

        let img = duplicate.querySelector("img");
		let dragZone = document.querySelector( "#container-canvas" );

		dragZone.appendChild( duplicate );

		let scale = parseFloat(target?.dataset?.scale ?? 1);

        if (scale > 1)
        {
            scale = 1;
        }

        let cloneWidth = img.naturalWidth * scale; //target.offsetWidth;
        let cloneHeight = img.naturalHeight * scale; //target.offsetHeight ;



		let offsetX = cloneWidth / -2;
        let offsetY = cloneHeight / -2
		let x       = event.pageX + offsetX;
		let y       = event.pageY + offsetY;

		//this.currentOffset = {x: event.offsetX, y: event.offsetY};
		this.currentOffset = { x : offsetX, y : offsetY };

		console.log( "img", img );
		console.log( "cloneWidth", cloneWidth, 'original', img.offsetWidth );
		console.log( "cloneHeight", cloneHeight, 'original', img.offsetHeight );
		console.log( "scale", scale );
		console.log( "x", x );
		console.log( "y", y );
		console.log( "this.currentOffset", this.currentOffset );
		console.log( "ratio", ratio );
		console.log( "event", event );

		duplicate.style.left = `${x}px`;
		duplicate.style.top  = `${y}px`;

		duplicate.style.width    = `${cloneWidth}px`;
		//duplicate.style.height  = `${target.offsetHeight}px`;

		duplicate.classList.add( "while-drag" )

		let randId   = new Date().getTime() + "_" + ((Math.random() * 0xFFFFFF) >> 0);
		let strID    = `duplicate_${randId}`
		duplicate.id = strID;

		duplicate.style.zIndex = "100";

		this.currentTargetSource.style.display = "none";

		return duplicate;
		// let position = {x,y};
		// interact(`#${strID}`)
		//     .draggable(
		//         {
		//                     manualStart: false,
		//                     listeners:
		//                         {
		//                             move (event)
		//                             {
		//                                 position.x += event.dx;
		//                                 position.y += event.dy;
		//
		//                                 duplicate.style.left = `${position.x}px`;
		//                                 duplicate.style.top = `${position.y}px`;
		//                             }
		//                         }
		//                });

	}

	addAsset ( image, target )
	{

		let random = window.seed;
		let url    = image.currentSrc;// + "?rand=" + random;

        let bottomPanel = document.querySelector(".bottom-panel");

        let bottomBounds = bottomPanel.getBoundingClientRect();
        let bottomHeight = bottomPanel.offsetHeight;

        let isLowerThanTopPanel = (bottomBounds.y + 20) < target.offsetTop;
        let bottomPanelY = (bottomBounds.y + bottomHeight);
        let bottomImageY =(target.offsetTop + image.height);
        let isLowerThanBottomPanel = bottomPanelY < bottomImageY;

        if (isLowerThanTopPanel ||  isLowerThanBottomPanel)
        {
            //since the top of the drag element is under the asset bar, we probably should not add it
            return;
        }

		let bounds    = {};
		bounds.width  = parseInt( image.width );
		bounds.height = parseInt( image.height );
		bounds.x      = target.offsetLeft;
		bounds.y      = target.offsetTop;
		console.log( "addAsset", image, target, image.currentSrc, image.src, bounds );

		let type = image.getAttribute( "data-type" );

		let fps  = image.getAttribute( "data-fps" ) ?? 1;
		let sfx  = JSON.parse( image.getAttribute( "data-sfx" ) ?? "{}" );
		let anim = JSON.parse( image.getAttribute( "data-anim" ) ?? "{}" );

		let asset = new Asset( url, bounds, type );
		asset.setAudioManager( this.audioManager );
		asset.setSfx( sfx )
		asset.setAnim( anim )
		this.container.addChild( asset );

		asset.on( "change-active", this.onChangeActive.bind( this ) )


		this.arrAssets.push( asset );

	}

	duplicateAsset ( assetDuplicate )
	{
		this.btnDuplicate.disabled = true;
		let bounds                 = assetDuplicate.getBounds();
		bounds.x += 25;
		bounds.y += 5;

		let asset = new Asset( assetDuplicate.url, bounds, assetDuplicate.type );
		setTimeout( () => asset.copySettings( assetDuplicate ), 2 );
		this.container.addChild( asset );

		asset.on( "change-active", this.onChangeActive.bind( this ) )


		this.arrAssets.push( asset );

		setTimeout( () => this.makeAssetActive( asset ), 50 );

		console.log( "duplicateAsset", bounds, asset );

		return asset;
	}

	makeAssetActive ( asset )
	{
		asset.makeActive();
		asset.onDragEnd();

		this.btnDuplicate.disabled = false;

	}

	removeTransformActions ()
	{
		this.panelTransform.classList.add( "panel-hidden" )
	}

	showTransformActions ()
	{
		this.panelTransform.classList.remove( "panel-hidden" )
	}


	onChangeActive ( active )
	{
		if ( this.currentActive && this.currentActive !== active )
		{
			this.currentActive.removeTransform();
			this.currentActive = null;
			this.removeTransformActions();
		}

		if ( active )
		{
			this.currentActive = active;
			this.showTransformActions();
		}

	}

	changeTransform ( mode )
	{
		if ( this.btnTransformActive )
		{
			this.btnTransformActive.classList.remove( "selected" );
		}

		const btns = { scale : this.btnScale, rotate : this.btnRotate };

		if ( this.currentActive )
		{
			this.btnTransformActive = btns[ mode ];

			this.btnTransformActive.classList.add( "selected" );

			this.currentActive.changeMode( mode );
		}

	}

	flip ()
	{
		if ( this.currentActive )
		{
			this.currentActive.flip();
		}
	}

	onNewText ( event )
	{
		if ( event.key === "Enter" )
		{
			let text                  = event.currentTarget.value;
			event.currentTarget.value = "";

			this.container.addChild( new TextAsset( text ) );
		}
	}

	duplicate ()
	{
		if ( this.currentActive )
		{
			let asset = this.duplicateAsset( this.currentActive );
			//this.btnScale.click();

			if ( this.btnTransformActive === this.btnRotate )
			{
				this.btnRotate.click();
				asset.changeMode( "rotate" );
			} else
			{
				this.btnScale.click();
			}

		}
	}

	deleteCurrent ()
	{
		if ( this.currentActive )
		{
			this.currentActive.parent.removeChild( this.currentActive );
			this.onChangeActive();
		}
	}

	reset ()
	{
		this.onChangeActive();

		this.arrAssets.forEach( a => this.container.removeChild( a ) );

		this.arrAssets = [];


		let audio = document.querySelector( "#background-music" );
		let src   = document.querySelector( "#audio-mp3" );

		let strURL = audio.getAttribute( "data-src" );

		console.log( strURL );

		src.setAttribute( "src", strURL );
		audio.load();
	}

	save ()
	{
		this.containerMask.addChild( this.gfxMask );
		this.container.mask = this.containerMask;

		let active = this.currentActive;
		this.onChangeActive( null )

		let imageBase64 = this.app.renderer.plugins.extract.base64( this.container );

		let a  = document.createElement( "a" ); //Create <a>
		a.href = imageBase64; //Image Base64 Goes here

		let now         = new Date().toLocaleString( "fr-CA", { timeZone : "America/New_York" } )
		let strFileName = "savoirs_legendaires_" + now;
		a.download      = `${strFileName}.png`; //File name Here
		a.click();

		this.container.mask = null;
		this.containerMask.removeChild( this.gfxMask );

		this.onChangeActive( active );

		let flash = document.querySelector( "#flash" );
		flash.classList.add( "white-flash" );

		this.audioManager.playOne( { name : "CAMERA" } );

		setTimeout( () => flash.classList.remove( "white-flash" ), 600 );

	}

	findBottomPanelTop ()
	{
		const activeBottomPanel = document.querySelector( '.bottom-panel:not(.panel-hidden)' );

		console.log( 'activeBottomPanel', activeBottomPanel );
		if ( !activeBottomPanel )
		{
			console.warn( 'No active bottom panel' );
			return 0;
		}


		const elBounds            = activeBottomPanel.getBoundingClientRect();
		const innerTitleTab       = activeBottomPanel.querySelector( '.title' );
		const innerTitleTabHeight = innerTitleTab.getBoundingClientRect().height;

		return elBounds.top - innerTitleTabHeight;


	}
}
